﻿import React from 'react';
import Lottie from 'lottie-react';

import infoIAnimationData from '../AnimationFiles/info_i.json';

const InfoLoader = (props) => {

    return (
        <div className="info-loader">
            <Lottie
                className="info-loader__animation"
                autoplay={true}
                loop={true}
                animationData={infoIAnimationData}
            />
            <p className="info-loader__text">{ props.loaderText }</p>
        </div>
    )
}

export default InfoLoader;